export enum EnumTpStatusMov {
    EmDigitacao = 10,
    Pendente = 20,
    Finalizado = 30,
    Cancelado = 40,
    Abortado = 50,
    Rejeitado = 60
}